// extracted by mini-css-extract-plugin
export var loading = "loading-module--loading--1CVsd";
export var text = "loading-module--text--SQ7gd";